import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useT } from "@/i18n/i18n";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { Logo, LanguageSwitcher } from "@/components/shared";
import { Field, Input, Select, Btn } from "@/pages/app/kit";
import { toast } from "sonner";

export default function Register() {
  const { t } = useT();
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "farmer", organization_name: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("OK");
      nav("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="hidden bg-forestdark p-10 lg:flex lg:flex-col lg:justify-between">
        <Logo light />
        <div>
          <h2 className="font-heading text-3xl font-bold text-white">{t("slogan")}</h2>
          <p className="mt-4 max-w-md text-white/70">{t("home.heroSub")}</p>
        </div>
        <div className="text-xs text-white/40">© {new Date().getFullYear()} Żywiąca Polska</div>
      </div>
      <div className="flex flex-col justify-center px-6 py-12 sm:px-12">
        <div className="mx-auto w-full max-w-sm">
          <div className="mb-6 flex items-center justify-between lg:hidden"><Logo /><LanguageSwitcher light={false} /></div>
          <h1 className="font-heading text-2xl font-bold text-charcoal">{t("auth.registerTitle")}</h1>
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
            <Field label={t("auth.name")} required><Input data-testid="register-name" value={form.name} onChange={set("name")} required /></Field>
            <Field label={t("auth.role")} required>
              <Select data-testid="register-role" value={form.role} onChange={set("role")}>
                <option value="farmer">{t("roles.farmer")}</option>
                <option value="buyer">{t("roles.buyer")}</option>
                <option value="processor">{t("roles.processor")}</option>
                <option value="beekeeper">{t("roles.beekeeper")}</option>
                <option value="investor">{t("roles.investor")}</option>
              </Select>
            </Field>
            <Field label={t("auth.org")}><Input data-testid="register-org" value={form.organization_name} onChange={set("organization_name")} /></Field>
            <Field label={t("auth.email")} required><Input data-testid="register-email" type="email" value={form.email} onChange={set("email")} required /></Field>
            <Field label={t("auth.password")} required hint="min. 8"><Input data-testid="register-password" type="password" value={form.password} onChange={set("password")} required minLength={8} /></Field>
            <Btn type="submit" className="w-full" disabled={busy} data-testid="register-submit">{busy ? "…" : t("auth.registerTitle")}</Btn>
          </form>
          <p className="mt-4 text-sm text-mutedtext">{t("auth.haveAccount")} <Link to="/login" className="font-semibold text-forest">{t("nav.login")}</Link></p>
        </div>
      </div>
    </div>
  );
}
